module.exports = __webpack_public_path__ + "static/img/lifestyle_13.1cc99318.jpg";